import { render, staticRenderFns } from "./HotRankList.vue?vue&type=template&id=fd7b4d10&scoped=true&"
import script from "./HotRankList.vue?vue&type=script&lang=ts&"
export * from "./HotRankList.vue?vue&type=script&lang=ts&"
import style0 from "./HotRankList.vue?vue&type=style&index=0&id=fd7b4d10&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd7b4d10",
  null
  
)

export default component.exports